import { jsx as _jsx } from "react/jsx-runtime";
import useResizeObserver from 'use-resize-observer';
export function ResponsiveChart(props) {
    const { width, height, minWidth, minHeight, maxWidth, maxHeight, children } = props;
    const observed = useResizeObserver();
    return (_jsx("div", { ref: observed.ref, style: {
            flex: 1,
            width: width || '100%',
            height: height || '100%',
            minWidth: minWidth || 0,
            minHeight: minHeight || 0,
            maxWidth,
            maxHeight,
        }, children: observed.width && observed.height
            ? children({ width: observed.width, height: observed.height })
            : null }));
}
//# sourceMappingURL=ResponsiveChart.js.map